// extracted by mini-css-extract-plugin
export default {"container":"IngresoPorDNI_container__Tt38g","buttonGroup":"IngresoPorDNI_buttonGroup__sTmkE","button":"IngresoPorDNI_button__On9nG"};